var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M960 512h-64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v365.714286H137.142857V137.142857h365.714286c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857H91.428571c-20.228571 0-36.571429 16.342857-36.571428 36.571428v841.142858c0 20.228571 16.342857 36.571429 36.571428 36.571428h841.142858c20.228571 0 36.571429-16.342857 36.571428-36.571428V521.142857c0-5.028571-4.114286-9.142857-9.142857-9.142857z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.6 538.171429L331.428571 674.057143c-0.114286 10.171429 8.114286 18.514286 18.285715 18.514286h0.457143l134.857142-3.314286c2.285714-0.114286 4.571429-1.028571 6.171429-2.628572l475.314286-474.285714c3.542857-3.542857 3.542857-9.371429 0-12.914286L824.457143 57.485714c-1.828571-1.828571-4.114286-2.628571-6.514286-2.628571s-4.685714 0.914286-6.514286 2.628571l-475.2 474.285715a9.485714 9.485714 0 0 0-2.628571 6.4z m72.571429 26.971428L817.942857 154.285714l51.657143 51.542857-412 411.085715-52.228571 1.257143 0.8-53.028572z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.1c5d014537f82f1dfe09714512a5147f.svg";
export { ForwardRef as ReactComponent };